export default __webpack_public_path__ + "static/media/error_bg.78101cc6.png";